export default __webpack_public_path__ + "resources/images/selection-pin.png";